import { getOfficeHierarchyById } from "../../../../actions/OfficeHierarchy";
import { useQuery, useQueryClient } from "react-query";
import { IdentificationIcon } from "@heroicons/react/24/solid";

export const useOfficeHierarchyById = (id) => {
  return useQuery(
    ["GetOfficeHierarchyById", id],
    () => getOfficeHierarchyById(id),
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
    }
  );
};
